import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const usePagination = (dispatchFunc, reducer, id, initialPerPage = 10) => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(initialPerPage);
  const dispatch = useDispatch();

  useEffect(() => {
    const offset = (page - 1) * perPage;
    if (id) {
      dispatch(dispatchFunc(perPage, offset, id));
    } else {
      dispatch(dispatchFunc(perPage, offset));
    }
  }, [page, perPage, id]);

  const total = useSelector((state) => state[`${reducer}Reducer`].total);
  const isLoading = useSelector((state) => state[`${reducer}Reducer`].isLoading);
  const dataSource = useSelector((state) => state[`${reducer}Reducer`][`${reducer}s`]);

  const handlePage = (e) => {
    setPage(e);
  };

  const handlePageSize = (current, size) => {
    setPerPage(size);
    setPage(1);
  };

  return {
    dataSource,
    total,
    handlePage,
    handlePageSize,
    page,
    isLoading,
    perPage
  };
};
